<template>
  <ListPageLayout :loading="tableLoading">
    <template #filter>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <el-input v-model="search.name" placeholder="登录账号"></el-input>
          </div>
          <div class="form-group">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              v-model.trim="search.startTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <el-date-picker
              value-format="yyyy-MM-dd HH:mm:ss"
              :editable="false"
              v-model.trim="search.endTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn" :disabled="tableLoading">
              <i v-if="tableLoading" class="el-icon-loading"></i>
              {{ tableLoading ? "查询中..." : "查询" }}
            </button>
            </span>
            <span class="search_btn">
              <button type="button" class="btn btn-default" @click="resetSearch">
                重置
              </button>
            </span>
          </div>
        </form>
      </div>
    </template>

    <el-table
      ref="table"
      border
      :data="tableListData.rows"
      height="100%"
      :header-cell-style="tableHeaderStyle"
      :cell-style="styleObj"
    >
      <el-table-column show-overflow-tooltip label="序号" prop="infoId"></el-table-column>
      <el-table-column show-overflow-tooltip label="登录账号" prop="loginName"></el-table-column>
      <el-table-column show-overflow-tooltip label="登录IP" prop="ipaddr"></el-table-column>
      <el-table-column show-overflow-tooltip label="登录地址" prop="loginLocation"></el-table-column>
      <el-table-column show-overflow-tooltip label="登录时间" prop="crtTime"></el-table-column>
    </el-table>

    <template #pagination>
      <Page v-on:pagination="receivePaginationData"></Page>
    </template>
  </ListPageLayout>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { dictValue, getconlog } from "@/api/url";

import Page from "../../commons/page.vue";
import ListPageLayout from "../../commons/ListPageLayout.vue";

import Refresh from "../../commons/refresh.vue";

export default {
  data() {
    return {
      tableLoading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      allOrderType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        status: "",
        name: "",
        startTime: "",
        endTime: "",
      },
      photo: {},
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      downloadFileds: {
        登录账号: "userName",
        登录IP: "loginIp",
        登录时间: "loginInTime",
        登出时间: "loginOutTime",
      },
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      this.tableLoading = true;
      this.$get(getconlog(), {
        loginName: this.search.name,
        limit: this.search.pageSize,
        page: curPage,
        beginTime: this.search.startTime,
        endTime: this.search.endTime,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData.rows = data.data.rows;
          _this.$nextTick(() => {
            if (_this.$refs.table && _this.$refs.table.doLayout) {
              _this.$refs.table.doLayout();
            }
          });
        })
        .finally(() => {
          _this.tableLoading = false;
        });
    },

    tableListAll: function () {
      this.$get(getconlog(), {}).then((data) => {
        this.tableListDataAll = data;
      });
    },
    searchList: function () {
      if (this.tableLoading) return;
      var flTime = this.timeCompare(this.search.startTime, this.search.endTime);
      // console.log(this.search.endTime)
      if (flTime) {
        return this.$layer.msg("开始时间请勿大于结束时间", { time: 1 });
      } else if (
        !Boolean(this.search.startTime) &&
        Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择开始时间", { time: 1 });
      } else if (
        Boolean(this.search.startTime) &&
        !Boolean(this.search.endTime)
      ) {
        return this.$layer.msg("请选择结束时间", { time: 1 });
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    timeCompare: function (bDateVal, eDateVal) {
      if (!Boolean(bDateVal) || !Boolean(eDateVal)) {
        return false;
      }
      var bdate = new Date(Date.parse(bDateVal.replace(/-/g, "/")));
      bdate = bdate.getTime();
      var edate = new Date(Date.parse(eDateVal.replace(/-/g, "/")));
      edate = edate.getTime();
      if (bdate - edate > 0) {
        return true;
      } else {
        return false;
      }
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.name = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.tableList(this.search.pageNumber);
    },
    resetSearch() {
      this.clearSearch();
      this.tableList(1);
    },
  },
  computed: mapState({
    curIndex: (state) => state.page.curIndex,
    rowsCount: (state) => state.page.rowsCount,
  }),
  components: {
    Page,
    ListPageLayout,
    Refresh,
  },
  created: function () {},
  mounted: function () {
    this.tableList(this.search.pageNumber);
    // this.tableListAll();
  },
};
</script>
<style scoped>
/* @import '@/assets/css/equip.css'; */
.list {
  padding: 0 !important;
}
.table thead {
  background: #f9f9fb;
}
.searchbox .el-input {
  width: 180px !important;
}
</style>